module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/sightseeing_2-669014581de70b27f1e948c8c169d18d.jpg";